import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { getHeaders,checkStatus } from "../../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;


// For fetching the record of Employee service.
export const getEmployeeList = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/List`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getEmployeeListDetailsByGUID = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Employee/UserId?GUID=${params.GUID}`, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

 
// For fetching the record of Employee Dashboard Count.
export const getEmployeeDashboardCount = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/EmployeeDashboardCount`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
 
// For Add Employee Data.
export const addEmployeeData = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/Add`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//Get Employee manager Name
export const getObserverName = async () => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Employee/Overseer`, {
      headers: await getHeaders(),
      body: JSON.stringify()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//Get Employee Keys Data.
export const getEmployeeKeys = async () => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Employee/EmployeeKey`, {
      headers: await getHeaders(),
      body: JSON.stringify()
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// For bulk upload excel file.
export const getUploadEmployees = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/UploadEmployee`,body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getValidateXmlData = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/ValidXmlData`,body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getEmployeeID = async (params) => {    
  try {
    const response = await axiosInstance.get(`${baseURL}/Employee/GenerateEmployementID?OrgId=${params.OrgId}`, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

//Bulk Update Employee
export const bulkEmployeeUpdate = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Employee/BulkUpdate`,params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// Bulk welcome mail send for User.
export const bulkWelcomeMail = async (params) => {
  try {
    const query = new URLSearchParams({
      EmployeeIds: params.EmployeeIds,
    }).toString();

    const response = await axiosInstance.post(`${baseURL}/Employee/WelcomeEmail?${query}`);
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
